import React from "react";
import ReactTooltip from "react-tooltip"
import InfiniteScroll from "react-infinite-scroll-component";
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import PropTypes from "prop-types";
import moment from "moment";

import { Row } from "../Layout"
import NTMButton from "../Buttons/NTMButton";
import CSVExporter from "components/Table/CSVExporter";
import style from "./_eventlog.module.scss"


export default class LogView extends React.Component {
	constructor(props) {
		super(props);
		this.buttonRef = React.createRef();

		this.state = {
			elements:[],
			startDate: null,
			endDate: null,
			scroll_step: 10,
			scroll_limit: 20,
			scroll_hasMore: true,
			scroll_items: [],
			interval: "daily"
		};
	}

	static getDerivedStateFromProps(props, state) {
		let elements = props.elements || [];
		let scroll_hasMore = elements.length > state.scroll_limit;
		let scroll_items = [];
		if(elements.length > 0) {
			scroll_items = elements.slice(0, Math.min(state.scroll_limit, elements.length));
		}
		return {elements, scroll_hasMore, scroll_items}
	}


	updateElements = (start = this.state.startDate, end = this.state.endDate) => {
		let params = {
			millis: end.valueOf(),
			day: end.diff(start, 'days') + 1
		};
		this.props.getElements(params);
		this.buttonRef.current.click();
	};

	fetchData = () => {
		let scroll_limit = this.state.scroll_limit + this.state.scroll_step;
		let scroll_hasMore;
		if(scroll_limit >= this.state.elements.length) {
			scroll_limit = this.state.elements.length;
			scroll_hasMore = false;
		} else {
			scroll_hasMore = true;
		}
		let scroll_items = this.state.elements.slice(0, Math.min(scroll_limit, this.state.elements.length));
		this.setState({
			scroll_limit,
			scroll_hasMore,
			scroll_items
		})
	};

	updateElementsInterval = (interval) => {
		let end = moment();
		let params = {
			millis: end.valueOf(),
			day: interval
		};
		this.props.getElements(params);
	};

	selectInterval = interval => {
		let startDate = null;
		let endDate = null;

		switch(interval) {
			case "daily":
				this.updateElementsInterval(1);
			    break;
			case "weekly": this.updateElementsInterval(7);
				break;
			case "monthly": this.updateElementsInterval(30);
				break;
			default:
				startDate=this.state.startDate;
				endDate=this.state.endDate;
				break;
		}
		this.setState({interval, startDate, endDate});
	};

	toCSVdata = data => {
		return data.map((item, index, array) => {
			let packetLost = index > 0 ? array[index-1].seqNumber - item.seqNumber - 1 : null;
			return {
				"Orario": moment(item.timestamp).tz("Europe/Rome").format("DD/MM/YYYY HH:mm"),
				"Seriale dispositivo": item.deviceId,
				"Tipo Messaggio": item.messageType,
				"Latitudine": item.lat,
				"Longitudine": item.lng,
				"Temperatura": item.temperature,
				"Batteria": item.bat,
				"Dato GPS valido": item.gpsValid,
				"Dispositivo aperto": item.phState,
				"Messaggi Persi": packetLost,
			}
		})
	}

	render() {

		let {showFilters = true} = this.props;

		return (

					<>
						{showFilters &&
						<Row className={style.buttonsRow}>
							<NTMButton
								primary={this.state.interval === "daily"}
								unselected={this.state.interval !== "daily" ? 'true' : undefined}
								onClick={() => this.selectInterval("daily")}
							>Oggi</NTMButton>
							<NTMButton
								primary={this.state.interval === "weekly"}
								unselected={this.state.interval !== "weekly" ? 'true' : undefined}
								onClick={() => this.selectInterval("weekly")}
							>Ultimi 7 gg</NTMButton>
							<NTMButton
								primary={this.state.interval === "monthly"}
								unselected={this.state.interval !== "monthly" ? 'true' : undefined}
								onClick={() => this.selectInterval("monthly")}
							>Ultimi 30 gg</NTMButton>

							<div data-tip data-for='global' data-event='click' ref={this.buttonRef}>
								<NTMButton
									primary={this.state.interval === "custom"}
									unselected={this.state.interval !== "custom" ? 'true' : undefined}
								>
									{
										this.state.startDate ?
											`${moment(this.state.startDate).format("DD/MM/YYYY")}
											-
											${moment(this.state.endDate).format("DD/MM/YYYY")}`
											: <>Scegli Periodo&nbsp;<i className="fa fa-caret-down"
											                           aria-hidden="true"/></>
									}
								</NTMButton>
							</div>
							<CSVExporter title={"Scarica"} name={"Tracker"} data={this.toCSVdata(this.props.elements)}/>
							<ReactTooltip
								id='global'
								aria-haspopup='true'
								effect='solid'
								place={"bottom"}
								clickable
								getContent={() => <DateRangePicker
									startDate={this.state.startDate} // momentPropTypes.momentObj or null,
									startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
									endDate={this.state.endDate} // momentPropTypes.momentObj or null,
									endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
									onDatesChange={({startDate, endDate}) => {
										this.setState({interval: "custom", startDate, endDate});
										if (startDate !== null && endDate !== null) {
											this.updateElements(startDate, endDate);

										}
									}} // PropTypes.func.isRequired,
									focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
									onFocusChange={focusedInput => this.setState({focusedInput})} // PropTypes.func.isRequired,
									withPortal={true}

									startDatePlaceholderText={"Inizio"}
									endDatePlaceholderText={"Fine"}
									displayFormat={"DD/MM/YYYY"}
									isOutsideRange={(o) => o.isAfter(moment(), 'day')}
									small={true}
								/>}
							/>
						</Row>
						}
						<div id={"scroll_container"} style={{height:"70vmin", overflow: "auto"}}>
							<InfiniteScroll
								dataLength={this.state.scroll_items.length} //This is important field to render the next data
								next={this.fetchData}
								hasMore={this.state.scroll_hasMore}
								loader={<h4>Loading...</h4>}
								endMessage={
									<div/>
								}
								scrollableTarget={"scroll_container"}
							>
								{this.state.scroll_items.map(this.props.getItem)}
							</InfiniteScroll>
						</div>
					</>
		);
	}
}

LogView.propTypes = {
	elements: PropTypes.array.isRequired,
	getElements: PropTypes.func.isRequired,
	getItem: PropTypes.func.isRequired,
	showFilters: PropTypes.bool
};
